/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Description_LengthInputs */

const fr_validation_description_length = /** @type {(inputs: Validation_Description_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitez la description à 2 000 caractères.`)
};

const en_validation_description_length = /** @type {(inputs: Validation_Description_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the description within 2,000 characters.`)
};

/**
* | output |
* | --- |
* | "Keep the description within 2,000 characters." |
*
* @param {Validation_Description_LengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_description_length = /** @type {((inputs?: Validation_Description_LengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Description_LengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_description_length(inputs)
	return fr_validation_description_length(inputs)
});